import { TrackerType } from '@futrli/shared-services';
import { eventTracker } from '@futrli/tracking';

import { injector } from './injector';

export const getTracker = () => {
  return injector.get('Tracker') as TrackerType;
};

export const { trackCTA, trackEvent, trackViewModal } = eventTracker(getTracker);

export const TRACKING_EVENTS = {
  CREATE_CONSOLIDATION_SINGLE_CURRENCY: 'Create consolidation single currency',
  CREATE_CONSOLIDATION_MULTI_CURRENCY: 'Create consolidation multi currency',
  CREATE_CONSOLIDATION_ELIMINATION: 'Create consolidation elimination',
  EDIT_FX_RATES_CONSOLIDATION: 'Edit FX rates consolidation'
};
